var _circle, _rect, _circle2, _ellipse, _path, _path2, _path3, _path4, _path5, _circle3, _circle4, _circle5, _circle6, _circle7, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoNotificationBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 202,
    viewBox: "0 0 214 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 103.907,
    cy: 106.931,
    r: 94.0837,
    fill: "#E8E8EC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 28.7163,
    y: 27.2041,
    width: 148.871,
    height: 148.116,
    fill: "url(#pattern0)",
    fillOpacity: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 79.7258,
    cy: 98.6184,
    r: 3.40062,
    fill: "#B7BAC6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 126.58,
    cy: 98.6184,
    rx: 3.40242,
    ry: 3.40062,
    fill: "#B7BAC6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M86.5054 107.521C102 109.5 103.5 110 118.271 107.941",
    stroke: "#B7BAC6",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M57.4326 124.65C108.291 128.233 150.481 124.571 148.824 123.934",
    stroke: "#B7BAC6",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M198.716 90.7696L201.699 80.055L209.487 87.9957L198.716 90.7696Z",
    stroke: "#12D377"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.75495 64.3884L4.55463 56.8366L12.1949 58.7069L6.75495 64.3884Z",
    stroke: "#12D377"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M44.818 18.2657L48.2832 13.5756L50.6123 18.9216L44.818 18.2657Z",
    stroke: "#12D377"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 196.48,
    cy: 160.207,
    r: 4.78985,
    stroke: "url(#paint0_linear_8177_21884)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 37.7843,
    cy: 105.796,
    r: 3.27846,
    stroke: "#EAA114"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 37.0286,
    cy: 42.3187,
    r: 2.52277,
    stroke: "url(#paint1_linear_8177_21884)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 85.7711,
    cy: 21.5372,
    r: 3.65631,
    stroke: "#101941"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 96.7288,
    cy: 63.4778,
    r: 2.82277,
    stroke: "#70758D",
    strokeWidth: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.4592 143.582V154.917M29.4717 149.709H39.2957",
    stroke: "url(#paint2_linear_8177_21884)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M208.269 135.27V146.605M203.281 141.397H213.105",
    stroke: "#70758D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M124.352 136.78V142.826M121.667 140.048H126.956",
    stroke: "#70758D",
    strokeWidth: 0.4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M123.597 71.0352V77.0807M120.911 74.303H126.201",
    stroke: "#70758D",
    strokeWidth: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8177_21884",
    transform: "matrix(0.00994924 0 0 0.01 0.00253807 0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8177_21884",
    x1: 191.19,
    y1: 165.497,
    x2: 201.77,
    y2: 154.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D62A07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C92503"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8177_21884",
    x1: 34.0059,
    y1: 45.3414,
    x2: 40.0514,
    y2: 39.2959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D62A07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C92503"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8177_21884",
    x1: 29.4717,
    y1: 154.917,
    x2: 40.692,
    y2: 145.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D62A07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C92503"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_8177_21884",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotificationBg);
export default __webpack_public_path__ + "static/media/no_notification_bg.6948730827fee0f8a366c93067db353e.svg";
export { ForwardRef as ReactComponent };